import { Box, IconButton, Typography } from '@mui/material'
import { IconEditPencil, IconTrashBin } from 'assets/icons'

type IntegrationItemProps = {
  title: string
  subtitle?: string
  onEdit: () => void
  onDelete?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

export const IntegrationItem = ({
  title,
  subtitle,
  onEdit,
  onDelete,
}: IntegrationItemProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      pl={3}
      pr={2.5}
      py={1.25}
      border="1px solid"
      borderColor="primary.light"
      borderRadius="12px"
      boxShadow="inset 0px 1px 1px rgba(237, 237, 248, 0.5), inset 0px 2px 10px rgba(162, 162, 175, 0.12)"
      bgcolor="alabaster"
    >
      <Box
        onClick={onEdit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          cursor: 'pointer',
        }}
      >
        <Typography variant="caption2" fontWeight={600}>
          {title}
        </Typography>

        {subtitle && <Typography variant="caption3">{subtitle}</Typography>}
      </Box>

      <Box display="flex">
        <IconButton onClick={onEdit}>
          <IconEditPencil sx={{ color: 'primary.main' }} />
        </IconButton>

        {onDelete && (
          <IconButton onClick={onDelete} sx={{ ml: 3, color: 'error.main' }}>
            <IconTrashBin />
          </IconButton>
        )}
      </Box>
    </Box>
  )
}
